import { Component } from '@angular/core';
import { inject } from "@vercel/analytics";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent {
  title = 'menu-app';

  constructor() {
    inject();
  }
}
